<template>
  <div class="customer-email-address-info">
    <router-link v-if="$hasPermission('view_customer')"
                 :to="{ name: 'customers.dashboard', params: { id: customer.uuid }}">
      {{ customer.display_name }}
    </router-link>
    <div v-else>
      <div class="mb-0">{{ customer.display_name }}</div>
    </div>
    <div v-if="customer && showAddress">
      <p class="mb-0" v-if="customer.billing_address"
         v-html="$options.filters.asAddress(customer.billing_address, false)">
      </p>
      <p class="mb-0" v-else-if="primary_billing_address"
         v-html="$options.filters.asAddress(primary_billing_address, false)">
      </p>
    </div>
    <p class="m-0" v-if="customer.email">
      {{ customer.email }}
    </p>
  </div>
</template>

<script>
  export default {
    name: "CustomerEmailAddressInfo",
    props: {
      customer: {
        type: Object,
        required: true
      },
      showIntraCommunityVatNumber: {
        type: Boolean,
        required: false
      },
      showAddress: {
        type: Boolean,
        default: true,
        required: false
      },
    },
    computed: {
      primary_billing_address() {
        if (this.customer && this.customer.addresses) {
          let address = this.customer.addresses.filter(address => address.is_primary && address.type === 'billing')
          return address[0] ? address[0] : null
        }
        return null
      }
    },
  }
</script>

<style scoped>

</style>
